// extracted by mini-css-extract-plugin
module.exports = {"container":"AboutWithCircles_container__2KoH5","about":"AboutWithCircles_about__aGQBA","stats":"AboutWithCircles_stats__2uyLu"};